export const PrintConstants = {
    PRINT_SHOW: 'PRINT_SHOW',
    PRINT_HIDE: 'PRINT_HIDE',
    PRINT_SET_CONTENT: 'PRINT_SET_CONTENT',
};